/**
 * ESCHER FALLS — 配色を DOM 側へ配る。
 *
 * three.js 側は `render/materials.ts` の `applyPalette` が持つ。
 * **両方に配らないと、盤面だけ／UIだけ着替わる。**
 */

import type { Skin } from '../game/skins';

function hex(n: number): string {
  return `#${n.toString(16).padStart(6, '0')}`;
}

/**
 * CSS 変数を差し替える。`:root` に載せるので、style.css の
 * `var(--paper)` などがすべて追随する。
 *
 * **個々の要素に色を直書きしている箇所があると、ここだけでは変わらない。**
 * 追加するときは必ず var() を通すこと。
 */
export function applyCssPalette(skin: Skin): void {
  const c = skin.colors;
  const root = document.documentElement.style;
  root.setProperty('--paper', hex(c.paper));
  root.setProperty('--paper-shade', hex(c.paperShade));
  root.setProperty('--ink', hex(c.ink));
  root.setProperty('--ink-soft', hex(c.inkSoft));
  root.setProperty('--water', hex(c.water));
  root.setProperty('--accent', hex(c.accent));

  // iOS のステータスバー下と、引っ張ったときの地の色。
  // これを忘れると、着替えても画面の縁だけ前の紙色が残る。
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta instanceof HTMLMetaElement) meta.content = hex(c.paper);
  document.body.style.background = hex(c.paper);
}
